import { useSelector } from 'react-redux';
import Login from './Login';
import { Navigate  } from 'react-router-dom';

const Home = () => {
  const user = useSelector((state) => state.user);


  return user?.isLoggedIn ? <Navigate to="/dashboard" />: <Login />;
};

export default Home;
